var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWeChatLight = props => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "none",
  viewBox: "0 0 32 24"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  fill: "#1aad19",
  rx: 4
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M13.64 13.86a.5.5 0 0 1-.69-.22l-.03-.07-1.41-3.17a.3.3 0 0 1-.03-.11c0-.15.12-.27.26-.27a.3.3 0 0 1 .16.05l1.66 1.22a.76.76 0 0 0 .7.08l7.82-3.57A8.2 8.2 0 0 0 15.75 5C11.47 5 8 7.96 8 11.61c0 2 1.04 3.79 2.68 5a.53.53 0 0 1 .19.6l-.35 1.33a.7.7 0 0 0-.04.2c0 .14.11.26.26.26.05 0 .1-.02.14-.05l1.7-1a.76.76 0 0 1 .64-.09c.8.23 1.65.36 2.53.36 4.28 0 7.75-2.96 7.75-6.6 0-1.11-.32-2.16-.88-3.07l-8.93 5.27z"
})));
export default SvgWeChatLight;